
import { ThemeProvider } from '@emotion/react';
import { CssBaseline, Grid, } from '@mui/material';
import React, { } from 'react';
import Menu from '../Menu';
import { RootProps } from './helper';
import Contact from '../Contact';
import { useToggle } from '../../helper/functions/hooks';
import { useSubscriber } from '../../helper/functions/hooks/events';
import { HIDE_BUTTON, MENU_CLICKED } from '../../events';
const Root = ({ theme, children }: RootProps): JSX.Element => {
    const { state: visible, toggle } = useToggle(true)
    useSubscriber<boolean>(HIDE_BUTTON,(e) =>{
        toggle(e)
    })
    useSubscriber<boolean>(MENU_CLICKED, (e) =>{ 
        toggle(e)
    })
    return (
        <ThemeProvider theme={theme}>
            <Menu />
            <CssBaseline />
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justifyContent="center">
                {children}
            </Grid>
            <Contact visible={visible}/>

        </ThemeProvider>
    )
}

export default Root;
